export default __webpack_public_path__ + "static/media/totop.e25c1be6.svg";